<template>
  <div>
    <div class="row">
      <breadcrumb>
        <template v-slot:1>
          <router-link :to="{ name: 'informes' }">{{
            $t("informes")
          }}</router-link>
        </template>
        <template v-slot:2>{{ $t("historicoDeProductos") }}</template>
      </breadcrumb>

      <CabeceraInformes
        :idBusiness="idBusiness"
        :listBusinesses="listBusinesses"
        :idTpv="idTpv"
        :listTpv="listTpv"
        :dateto="dateto"
        :datefrom="datefrom"
        id="cabecera"
        :conBuscador="true"
        :textoExtraPlaceholder="$t('buscarPorNombreDelProducto')"
        :textoExtra="$t('producto')"
        :listElmExtra="listProductos"
      />
      <template v-if="!permiso">
        <div class="alert alert-danger m-3" style="width: 100%" role="alert">
            Lo sentimos. Este negocio no cuenta con este módulo activado.
        </div>
      </template>
      <div class="col-md-12" v-else-if="respuesta">
        <template v-if="list.length > 0">
          <div class="row">
            <template v-if="!cambioVista">
              <div class="col-md-12 col-xs-12 text-left">
                <el-dropdown>
                  <el-button type="primary" size="small">
                    <i class="fa fa-file"></i>
                    {{ $t("exportarInforme") }}
                    <i class="el-icon-arrow-down el-icon--right"></i>
                  </el-button>
                  <el-dropdown-menu slot="dropdown">
                    <a :href="urlExportPDF">
                      <el-dropdown-item class="text-danger">
                        <strong
                          ><i class="fa fa-file-pdf"></i>
                          {{ $t("exportarPdf") }}</strong
                        >
                      </el-dropdown-item>
                    </a>
                    <a :href="urlExportExcel">
                      <el-dropdown-item class="text-success">
                        <strong
                          ><i class="fa fa-file-excel"></i>
                          {{ $t("exportarExcel") }}</strong
                        >
                      </el-dropdown-item>
                    </a>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </template>

            <template v-if="!cambioVista">
              <div class="col-md-8">
                <div class="table-responsive">
                  <table class="table table-bordered table-striped text-nowrap">
                    <thead class="thead-dark">
                      <tr style="cursor: pointer">
                        <th
                          v-if="ordenacionFecha === 0"
                          @click="sortedArrayFechaASC()"
                        >
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("fecha") }}
                        </th>
                        <th v-else @click="sortedArrayFechaDESC()">
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("fecha") }}
                        </th>
                        <th
                          v-if="ordenacionProductos === 0"
                          @click="sortedArrayNameASC('name')"
                        >
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("producto") }}
                        </th>
                        <th v-else @click="sortedArrayNameDESC('name')">
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("producto") }}
                        </th>
                        <th
                          v-if="ordenarCantidad === 0"
                          @click="sortedArrayCantidadASC('cantidad')"
                        >
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("cantidad") }}
                        </th>
                        <th v-else @click="sortedArrayCantidadDESC('cantidad')">
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("cantidad") }}
                        </th>
                        <th
                          v-if="ordenarImporte === 0"
                          @click="sortedArrayImporteASC('importe')"
                        >
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("importe") }}
                        </th>
                        <th v-else @click="sortedArrayImporteDESC('importe')">
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("importe") }}
                        </th>
                        <th
                          v-if="ordenarPrecioMed === 0"
                          @click="sortedArrayPrecioMedASC('importe/cantidad')"
                        >
                          <i style="color: white" class="fa fa-angle-up"></i>
                          {{ $t("precioMed") }}
                        </th>
                        <th
                          v-else
                          @click="sortedArrayPrecioMedDESC('importe/cantidad')"
                        >
                          <i style="color: white" class="fa fa-angle-down"></i>
                          {{ $t("precioMed") }}
                        </th>
                        <th>{{ $t("acciones") }}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="obj in list">
                        <td>{{ obj.fecha | parseDate }}</td>
                        <td>{{ obj.name }}</td>
                        <td align="right">
                          <span v-if="obj.pedirPeso" class="text-primary"
                            >{{ obj.cantidad }} Kg.</span
                          >
                          <span v-else>{{ obj.cantidad }}</span>
                        </td>
                        <td class="text-right">{{ obj.importe | currency }}</td>
                        <td class="text-right">
                          {{ (obj.importe / obj.cantidad) | currency }}
                        </td>
                        <td width="5%" align="center">
                          <div class="btn btn-link">
                            <i
                              @click="getTickets(obj.idDay)"
                              class="fas fa-arrow-circle-right"
                              style="cursor: pointer"
                              v-tooltip.top-center="
                                $i18n.t('verTicketsDelProducto')
                              "
                            ></i>
                          </div>

                          <div class="btn btn-link">
                            <template v-if="obj.tarifas">
                              <i
                                @click="getTarifas(obj.idDay)"
                                class="fas fa-list-ol"
                                style="cursor: pointer"
                                v-tooltip.top-center="
                                  $t('verDesgloseDeTarifas')
                                "
                              ></i>
                            </template>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr class="table-success">
                        <td>
                          <strong>{{ $t("total") }}</strong>
                        </td>
                        <td></td>
                        <td class="text-right">
                          <strong>{{ getTotalCantidad }}</strong>
                        </td>
                        <td class="text-right">
                          <strong>{{ getTotalPrecio | currency }}</strong>
                        </td>
                        <td></td>
                        <td></td>
                      </tr>
                    </tfoot>
                  </table>
                </div>
              </div>
              <div class="col-md-4">
                <div class="row">
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-9">
                        <strong>{{ $t("ventasPorMeses") }} </strong>
                      </div>
                      <div class="col-md-3">
                        <template v-if="!botonGraficaUnoCantidad">
                          <button
                            @click="initChartWeek()"
                            class="btn btn-primary"
                          >
                            <i class="fas fa-th-large"></i> {{ $t("unidades") }}
                          </button>
                        </template>
                        <template v-else>
                          <button
                            @click="initChartWeek()"
                            class="btn btn-primary"
                          >
                            <i class="fas fa-coins"></i> {{ $t("importe") }}
                          </button>
                        </template>
                      </div>
                      <div class="col-md-12">
                        <div
                          class="chart-container"
                          style="height: 200px; width: 100%"
                        >
                          <canvas id="chart"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <hr />
                  </div>
                  <div class="col-md-12">
                    <div class="row">
                      <div class="col-md-9">
                        <strong>{{ $t("ventasHoras") }} </strong>
                      </div>
                      <div class="col-md-3">
                        <template v-if="!botonGraficaDosCantidad">
                          <button
                            class="btn btn-primary"
                            @click="initChartHours()"
                          >
                            <i class="fas fa-th-large"></i> {{ $t("unidades") }}
                          </button>
                        </template>
                        <template v-else>
                          <button
                            @click="initChartHours()"
                            class="btn btn-primary"
                          >
                            <i class="fas fa-coins"></i>
                            {{ $t("importe") }}
                          </button>
                        </template>
                      </div>
                      <div class="col-md-12">
                        <div
                          class="chart-container"
                          style="height: 200px; width: 100%"
                        >
                          <canvas id="charthour"></canvas>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="col-md-12">
                <button @click="cambioVista = false" class="btn btn-primary">
                  <i class="fas fa-arrow-circle-left"></i>
                  {{ $t("volverALaLista") }}
                </button>

                <template v-for="ticket in listTickets">
                  <ticket :ticket="ticket"></ticket>
                </template>
              </div>
            </template>
          </div>
        </template>
        <template v-else>
          <div class="alert alert-danger" role="alert">
            {{ $t("noHayVentasDeProductosEnEsteRangoDeFechas") }}
          </div>
        </template>
      </div>

      <modal
        name="filtradoTPV"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("filtrarPorTPV") }}</h4>
          </div>
          <div class="modal-body">
            <el-checkbox-group :min="1" v-model="idsTPV" size="medium">
              <el-checkbox
                v-for="tpv in listCheckBoxTpv"
                :label="tpv.id"
                :key="tpv.id"
                border
              >
                {{ tpv.nameShow }}
              </el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12">
              <button class="btn btn-primary" @click="getSalesProducts()">
                <i class="fa fa-search"></i>
                {{ $t("filtrarTPV") }}
              </button>
            </div>
          </div>
        </div>
      </modal>

      <modal
        name="mostrar-Tarifas"
        :adaptive="true"
        :scrollable="true"
        height="auto"
        :clickToClose="true"
      >
        <div>
          <div class="modal-header">
            <h4 style="margin: 0px">{{ $t("tarifasDelProducto") }}</h4>
          </div>
          <div class="modal-body">
            <table class="table table-bordered table-striped text-nowrap">
              <thead class="thead-dark">
                <tr style="cursor: pointer">
                  <th>{{ $t("tarifa") }}</th>
                  <th>{{ $t("cantidad") }}</th>
                  <th>{{ $t("importe") }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="obj in listTarifas">
                  <td>{{ obj.name }}</td>
                  <td>{{ obj.cantidad }}</td>
                  <td>{{ obj.importe | currency }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="modal-footer">
            <div align="right" class="col-12"></div>
          </div>
        </div>
      </modal>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import Chart from "chart.js";
import {
  DatePicker,
  Select,
  Option,
  Dropdown,
  Loading,
  DropdownItem,
  DropdownMenu,
  Button,
  Checkbox,
  CheckboxGroup,
} from "element-ui";
import swal from "sweetalert2";
import moment from "moment";
import CabeceraInformes from "../../../../components/CabeceraInformes/CabeceraInformes";
import bus from "../../../../bus";
import Ticket from "../../../Widgets/Ticket.vue";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb.vue";
import { mapState } from 'vuex'

export default {
  created() {
    this.loading = Loading.service({ text: "Cargando..." });
    this.$store.dispatch("setNameRoute", this.$i18n.t("historicoDeProductos"));
    this.getBusiness();

    if (this.$store.getters.dateTo && this.$store.getters.dateFrom) {
      this.datefrom = this.$store.getters.dateFrom;
      this.dateto = this.$store.getters.dateTo;
    }
  },
  components: {
    CabeceraInformes,
    [DatePicker.name]: DatePicker,
    [Select.name]: Select,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Button.name]: Button,
    [Option.name]: Option,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    ticket: Ticket,
    Breadcrumb,
  },
  data() {
    return {
      loading: false,
      loadingScreen: false,
      datefrom: new Date(
        new Date().getFullYear(),
        new Date().getMonth(),
        1
      ).toISOString(),
      dateto: new Date().toISOString(),
      listBusinesses: [],
      idBusiness: 0,
      value4: [
        new Date(new Date().getFullYear(), new Date().getMonth(), 1),
        new Date(),
      ],
      list: [],
      mode: 0,
      $Chart: null,
      contador: 0,
      chartIn: 0,
      listTpv: [],
      idTpv: 0,
      dateRangeOptions1: {
        firstDayOfWeek: 1,
      },
      listCheckBoxTpv: [],
      idsTPV: [],
      objectChart: null,
      objectChart2: null,
      ordenacionFecha: 0,
      ordenacionProductos: 0,
      ordenarCantidad: 0,
      ordenarImporte: 0,
      ordenarPrecioMed: 0,

      //LISTA PRODUCTOS

      listProductos: [],
      idProduct: "",

      respuesta: true,

      //LISTA SALEES PRODUCTOS POR MESES Y HORAS
      listMonth: [],
      listHour: [],

      // VISTA TICKETS
      listTickets: [],
      cambioVista: false,

      //TARIFAS
      listTarifas: [],

      //BOTONES DEL CHART
      botonGraficaUnoCantidad: false,
      botonGraficaDosCantidad: false,
    };
  },
  computed: {
    ...mapState(["permiso"]),
    urlExportPDF() {
      var tpv = "";

      this.idsTPV.forEach(function(d) {
        tpv += d + ",";
      });

      return (
        this.$store.getters.apiUrl +
        "/products/exportVentasByProduct/PDF?idBusiness=" +
        this.idBusiness +
        "&idProduct=" +
        this.idProduct +
        "&idTpv=" +
        tpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },
    urlExportExcel() {
      var tpv = "";

      this.idsTPV.forEach(function(d) {
        tpv += d + ",";
      });

      return (
        this.$store.getters.apiUrl +
        "/products/exportVentasByProduct/Excel?idBusiness=" +
        this.idBusiness +
        "&idProduct=" +
        this.idProduct +
        "&idTpv=" +
        tpv +
        "&datefrom=" +
        moment(this.datefrom)
          .startOf("day")
          .unix() +
        "&dateto=" +
        moment(this.dateto)
          .endOf("day")
          .unix() +
        "&jwt=" +
        this.$store.getters.jwt
      );
    },

    getTotalPrecio() {
      let total = 0;
      this.list.forEach(function(d) {
        total += parseFloat(d.importe);
      });
      return total;
    },

    getTotalCantidad() {
      let total = 0;
      this.list.forEach(function(d) {
        total += parseFloat(d.cantidad);
      });
      return total;
    },
  },
  methods: {
    cambiarExtra(elem) {
      this.idProduct = elem;
    },
    searchCabecera(query) {
      this.searchProducto(query);
    },
    cambioBusiness(idBusinessData,listTpv) {
      this.loading = Loading.service({ text: "Cargando..." });
      this.idBusiness = idBusinessData;
      this.idTpv = listTpv[0].id;
      this.changeTPV();
      if (listTpv) {
        this.listTpv = listTpv;
      }
    },
    emitirConsulta() {
      this.loading = Loading.service({ text: "Cargando..." });

      this.getSalesProducts();
    },
    cambioTpv(idTpvData, filtrar) {

        if (idTpvData != undefined) {
            this.idTpv = idTpvData;
            this.mostrarTicket = false;
            this.changeTPV();
        }
        
        this.idTpv=idTpvData;
        this.emitirConsulta();
    },
    cambioHora(dates) {
      if (dates) {
        this.datefrom = dates[0];
        this.dateto = dates[1];
      }
    },
    sortedArrayFechaASC: function() {
      this.ordenacionFecha = 1;

      function compare(a, b) {
        if (a.fecha < b.fecha) return -1;
        if (a.fecha > b.fecha) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayFechaDESC: function() {
      this.ordenacionFecha = 0;

      function compare(a, b) {
        if (a.fecha > b.fecha) return -1;
        if (a.fecha < b.fecha) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    sortedArrayNameASC: function() {
      this.ordenacionProductos = 1;

      function compare(a, b) {
        if (a.name.toUpperCase() < b.name.toUpperCase()) return -1;
        if (a.name.toUpperCase() > b.name.toUpperCase()) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayNameDESC: function() {
      this.ordenacionProductos = 0;

      function compare(a, b) {
        if (a.name.toUpperCase() > b.name.toUpperCase()) return -1;
        if (a.name.toUpperCase() < b.name.toUpperCase()) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadASC: function() {
      this.ordenarCantidad = 1;

      function compare(a, b) {
        if (a.cantidad < b.cantidad) return -1;
        if (a.cantidad > b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayCantidadDESC: function() {
      this.ordenarCantidad = 0;

      function compare(a, b) {
        if (a.cantidad > b.cantidad) return -1;
        if (a.cantidad < b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayImporteASC: function() {
      this.ordenarImporte = 1;

      function compare(a, b) {
        if (a.importe < b.importe) return -1;
        if (a.importe > b.importe) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayImporteDESC: function() {
      this.ordenarImporte = 0;

      function compare(a, b) {
        if (a.importe > b.importe) return -1;
        if (a.importe < b.importe) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayPrecioMedASC: function() {
      this.ordenarPrecioMed = 1;

      function compare(a, b) {
        if (a.importe / a.cantidad < b.importe / b.cantidad) return -1;
        if (a.importe / a.cantidad > b.importe / b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },
    sortedArrayPrecioMedDESC: function() {
      this.ordenarPrecioMed = 0;

      function compare(a, b) {
        if (a.importe / a.cantidad > b.importe / b.cantidad) return -1;
        if (a.importe / a.cantidad < b.importe / b.cantidad) return 1;
        return 0;
      }

      return this.list.sort(compare);
    },

    changeTPV() {
        /*if (this.idTpv === -1) {

          this.idsTPV = [];

          for (let i = 0; i < this.listTpv.length; i++) {
              this.idsTPV.push(this.listTpv[i].id)
          }

        } else {*/
          this.idsTPV = []
          this.idsTPV.push(this.idTpv)
        //}
    },

    openModal() {
      this.$modal.show("filtradoTPV");
    },

    getTpv() {
      this.listTpv = [];

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getTpvsByBusiness", config)
        .then(function(response) {
          if (response.data.response) {
            vm.listProductos = [];
            vm.idsTPV = [];
            vm.listTpv = [];

            vm.idProduct = "";

            for (let i = 0; i < response.data.result.length; i++) {
              vm.idsTPV.push(response.data.result[i].id);
            }

            var prims = {"boolean":{}, "number":{}, "string":{}}, objs = [];

            vm.idsTpv = vm.idsTpv && vm.idsTpv.filter(function(item) {
                var type = typeof item;
                if(type in prims)
                    return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
                else
                    return objs.indexOf(item) >= 0 ? false : objs.push(item);
            });

            vm.listCheckBoxTpv = response.data.result;

            for (let i = 0; i < response.data.result.length; i++) {
              let printername = {
                nameShow: response.data.result[i].nameShow,
                id: response.data.result[i].id,
              };

              vm.listTpv.push(printername);
            }

            var prims = {"boolean":{}, "number":{}, "string":{}}, objs = [];

            vm.listTpv = vm.listTpv && vm.listTpv.filter(function(item) {
                var type = typeof item;
                if(type in prims)
                    return prims[type].hasOwnProperty(item) ? false : (prims[type][item] = true);
                else
                    return objs.indexOf(item) >= 0 ? false : objs.push(item);
            });

            vm.getSalesProducts();
          }
          vm.loading.close();
        })
        .catch(function(error) {
          console.error(error);
        });
    },

    getBusiness() {
      var config = {
        params: {
          jwt: this.$store.getters.jwt,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(this.$store.getters.apiUrl + "general/getBusinessesByUser", config)
        .then(function(response) {

          vm.listBusinesses = response.data.result;

          if (vm.$store.getters.idBusiness) {
            vm.idBusiness = vm.$store.getters.idBusiness;
          } else {
            vm.idBusiness = response.data.result[0].id;
          }

          vm.getTpv();
        })
        .catch(function(error) {
          console.error(error);
        });
    },
    getSalesProducts() {
      if (this.idProduct !== "") {
        this.$modal.hide("filtradoTPV");

        if (this.datefrom === null || this.dateto === null) {
          swal({
            title: this.$t("todos"),
            text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          let secondsDesde = moment(this.datefrom).unix();
          let secondsHasta = moment(this.dateto).unix();

          if (secondsHasta < secondsDesde) {
            swal({
              title: this.$t("ups"),
              text: this.$t("laFechaDeInicioNoPuedeSerPosteriorALaDeFin"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          } else {
            this.loading = Loading.service({ text: "Cargando..." });

            this.$store.dispatch("setDateTo", this.dateto);
            this.$store.dispatch("setDateFrom", this.datefrom);

            var config = {
              params: {
                idBusiness: this.idBusiness,
                datefrom: moment(this.datefrom)
                  .startOf("day")
                  .unix(),
                dateto: moment(this.dateto)
                  .endOf("day")
                  .unix(),
                idTpv: this.idsTPV,
                idProduct: this.idProduct,
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
              .get(
                this.$store.getters.apiUrl + "products/getSalesProduct",
                config
              )
              .then(function(response) {
                if (response.data.response) {
                  vm.list = response.data.result.dias;
                  vm.listMonth = response.data.result.meses;

                  vm.respuesta = true;

                  vm.getSalesProductHours();
                }else if (response.data.response == false && response.data.rangoMayor == true) {
                  swal({
                  title: "Lo sentimos",
                  text: response.data.result,
                  confirmButtonClass: "btn btn-info btn-fill",
                  type: "info",
                  });
                  vm.respuesta = false;
              } else {
                  swal({
                    title: vm.$t("atencion"),
                    text: response.data.message,
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                  vm.respuesta = false;
                }
                vm.loading.close();
              })
              .catch(function(error) {
                console.error(error);
              });
          }
        }
      } else {
        this.loading.close();
      }
    },
    getSalesProductHours() {
      if (this.idProduct !== "") {
        this.$modal.hide("filtradoTPV");

        if (this.datefrom === null || this.dateto === null) {
          swal({
            title: this.$t("ups"),
            text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
            confirmButtonClass: "btn btn-info btn-fill",
            type: "error",
          });
        } else {
          let secondsDesde = moment(this.datefrom).unix();
          let secondsHasta = moment(this.dateto).unix();

          if (secondsHasta < secondsDesde) {
            swal({
              title: this.$t("ups"),
              text: this.$t("seleccioneUnaFechaDeInicioYUnaFechaDeFin"),
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          } else {
            this.loading = Loading.service({ text: "Cargando..." });

            this.$store.dispatch("setDateTo", this.dateto);
            this.$store.dispatch("setDateFrom", this.datefrom);

            var config = {
              params: {
                idBusiness: this.idBusiness,
                datefrom: moment(this.datefrom)
                  .startOf("day")
                  .unix(),
                dateto: moment(this.dateto)
                  .endOf("day")
                  .unix(),
                idTpv: this.idsTPV,
                idProduct: this.idProduct,
                jwt: this.$store.getters.jwt,
              },
              headers: { Authorization: "Bearer " + this.$store.getters.jwt },
            };

            let vm = this;
            this.$store.dispatch("setIdBusiness", this.idBusiness);
            this.axios
              .get(
                this.$store.getters.apiUrl + "products/getSalesProductHours",
                config
              )
              .then(function(response) {
                if (response.data.response) {
                  vm.listHour = response.data.result;

                  vm.respuesta = true;

                  vm.initChartHours();
                  vm.initChartWeek();
                } else {
                  swal({
                    title: vm.$t("accesoDenegado"),
                    text: vm.$t("noTienesPermisoParaVisualizarEsteInforme"),
                    confirmButtonClass: "btn btn-info btn-fill",
                    type: "error",
                  });
                  vm.respuesta = false;
                }
                vm.loading.close();
              })
              .catch(function(error) {
                console.error(error);
              });
          }
        }
      }
    },

    searchProducto(query) {
      if (query !== "") {
        const controller = "searchProductsById/" + query;
        var config = {
          params: {
            idBusiness: this.idBusiness,
            idsTpv: [this.idTpv],
            jwt: this.$store.getters.jwt,
          },
          headers: { Authorization: "Bearer " + this.$store.getters.jwt },
        };

        let vm = this;
        this.axios
          .get(this.$store.getters.apiUrl + "products/" + controller, config)
          .then(function(response) {
            if (response.data.response) {
              vm.listProductos = response.data.result.products;
            } else {
              swal({
                title: vm.$t("atencion"),
                text: response.data.message,
                confirmButtonClass: "btn btn-info btn-fill",
                type: "error",
              });
            }
          })
          .catch(function(error) {
            console.error(error);
          });
      }
    },

    getTickets(idDay) {
      this.loading = Loading.service({ text: "Cargando..." });

      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          id: this.idProduct,
          idDay: idDay,
          datefrom: moment(this.datefrom)
            .startOf("day")
            .unix(),
          dateto: moment(this.dateto)
            .endOf("day")
            .unix(),
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getTicketsByIdProduct",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listTickets = response.data.result.tickets;
            vm.cambioVista = true;

            vm.loading.close();
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.error(error);
        });
    },

    getTarifas(idDay) {
      var config = {
        params: {
          idBusiness: this.idBusiness,
          jwt: this.$store.getters.jwt,
          idTpv: this.idsTPV,
          idProduct: this.idProduct,
          idDay: idDay,
        },
        headers: { Authorization: "Bearer " + this.$store.getters.jwt },
      };

      let vm = this;
      this.axios
        .get(
          this.$store.getters.apiUrl + "products/getSalesProductsByTarifa",
          config
        )
        .then(function(response) {
          if (response.data.response) {
            vm.listTarifas = response.data.result;

            vm.$modal.show("mostrar-Tarifas");
          } else {
            swal({
              title: vm.$t("atencion"),
              text: response.data.message,
              confirmButtonClass: "btn btn-info btn-fill",
              type: "error",
            });
          }
        })
        .catch(function(error) {
          console.error(error);
        });
    },

    initChartWeek() {
      if (this.botonGraficaUnoCantidad) {
        this.botonGraficaUnoCantidad = false;
      } else {
        this.botonGraficaUnoCantidad = true;
      }

      let vm = this;
      var labels = this.listMonth.map(function(x) {
        var humanDate = moment.unix(x.fecha);

        return moment(humanDate).format("MMMM");
      });

      if (this.botonGraficaUnoCantidad) {
        var data = this.listMonth.map(function(x) {
          return x.importe;
        });
      } else {
        var data = this.listMonth.map(function(x) {
          return x.cantidad;
        });
      }

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      if (this.objectChart !== null) {
        this.objectChart.destroy();
      }

      this.objectChart = new Chart("chart", {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: backgroundColors,
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            display: false,
            position: "bottom",
          },
          responsive: true,
          maintainAspectRatio: false,
        },
      });
    },

    initChartHours() {
      if (this.botonGraficaDosCantidad) {
        this.botonGraficaDosCantidad = false;
      } else {
        this.botonGraficaDosCantidad = true;
      }

      let vm = this;
      var labels = this.listHour.map(function(x) {
        return x.horas;
      });

      if (this.botonGraficaDosCantidad) {
        var data = this.listHour.map(function(x) {
          return x.amount;
        });
      } else {
        var data = this.listHour.map(function(x) {
          return x.cantidad;
        });
      }

      var randomColor = require("randomcolor");

      var colors = randomColor({
        luminosity: "dark",
        count: labels.length,
        format: "rgb",
      });

      let backgroundColors = colors.map(function(x) {
        let xcolors = x.substring(x.indexOf("(") + 1, x.length - 1).split(",");
        return (
          "rgba(" + xcolors[0] + "," + xcolors[1] + "," + xcolors[2] + ", 0.6)"
        );
      });

      if (this.objectChart2 !== null) {
        this.objectChart2.destroy();
      }

      this.objectChart2 = new Chart("charthour", {
        type: "bar",
        data: {
          labels: labels,
          datasets: [
            {
              data: data,
              backgroundColor: backgroundColors,
              borderWidth: 1,
            },
          ],
        },
        options: {
          legend: {
            display: false,
            position: "bottom",
          },
          responsive: true,
          beginAtZero: true,
          maintainAspectRatio: false,
        },
      });
    },
  },
};
</script>

<style scoped>
a li {
  color: #111;
}

.card {
  padding: 20px;
}

.div-export {
  margin-bottom: 10px;
}

body {
  background: #1d1f20;
  padding: 16px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Informes/Productos/HistoricoProductos.vue